import { render, staticRenderFns } from "./AboutMain.vue?vue&type=template&id=1556af6d"
import script from "./AboutMain.vue?vue&type=script&lang=js"
export * from "./AboutMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports